export default __webpack_public_path__ + "static/media/StarFill_yellow.c3d6b63b.svg";